import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex w-100 justify-space-between" }
const _hoisted_2 = { class: "d-flex gap-1" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "d-flex",
  style: {"position":"absolute","right":"20px"}
}
const _hoisted_6 = { class: "d-flex align-center clock" }
const _hoisted_7 = { class: "text-danger" }


import { AtomStar, ClockIcon } from '@/components/atoms';
import { getPriorityClass, priorityMapping } from '@/core/enum/priority';

export interface ICardItem {
  title: string;
  subtitle: string | number | undefined;
  type?: 'priority' | 'rating';
}

interface IProps {
  items: ICardItem[];
  hours?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardData',
  props: {
    items: {},
    hours: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["d-flex flex-column", { 'ml-8': index > 0 }])
        }, [
          _createVNode(_component_v_card_title, { class: "title text-md pb-1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_card_subtitle, { class: "subtitle text-sm" }, {
            default: _withCtx(() => [
              (item.type === 'priority')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_unref(getPriorityClass)(_unref(priorityMapping)[item.subtitle!]))
                  }, _toDisplayString(_unref(priorityMapping)[item.subtitle!]), 3))
                : (item.type === 'rating')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createVNode(_unref(AtomStar), {
                        size: "20px",
                        rating: item.subtitle
                      }, null, 8, ["rating"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.subtitle), 1))
            ]),
            _: 2
          }, 1024)
        ], 2))
      }), 128))
    ]),
    (_ctx.hours)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ClockIcon), {
              class: "mr-1",
              style: {"fill":"#F43841"}
            }),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.hours), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})